import { ArrowRight, ShieldCheck } from 'lucide-react';
import { useDemoModal } from '../demo-modal-context';

export function Hero() {
  const { open } = useDemoModal();
  return (
    <section className="relative isolate overflow-hidden">
      <div className="absolute inset-0 grid-pattern -z-10" aria-hidden />
      <div className="absolute inset-x-0 -top-32 -z-10 h-[480px] bg-gradient-to-b from-primary-soft/40 to-transparent" aria-hidden />

      <div className="container-page flex min-h-[88vh] flex-col justify-center pb-20 pt-20 md:pt-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-white px-3 py-1 text-xs font-medium text-ink-2 shadow-sm">
            <ShieldCheck className="h-3.5 w-3.5 text-primary" />
            HIPAA-aligned chain of custody
          </span>

          <h1 className="mt-6 text-4xl font-semibold leading-[1.1] tracking-tight text-ink md:text-6xl">
            Chain-of-custody records for every prescription that leaves your pharmacy.
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-2 md:text-xl">
            Audit-defensible delivery records — geofence-verified, photo-documented, signature-confirmed —
            built for pharmacies that need to prove every delivery.
          </p>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={open}
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-ink px-5 py-3 text-sm font-medium text-white shadow-sm transition-colors hover:bg-ink/90"
            >
              Request a demo
              <ArrowRight className="h-4 w-4" />
            </button>
            <a
              href="#how-it-works"
              className="inline-flex items-center justify-center rounded-lg border border-border bg-white px-5 py-3 text-sm font-medium text-ink transition-colors hover:bg-bg-muted"
            >
              See how it works
            </a>
          </div>

          <dl className="mt-14 grid max-w-xl grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-3">
            {[
              ['Geofence', 'GPS-verified pickup & delivery'],
              ['Evidence', 'Photo, signature, timestamp'],
              ['Export', 'PDF in 5 seconds'],
            ].map(([term, desc]) => (
              <div key={term}>
                <dt className="text-xs font-medium uppercase tracking-wide text-ink-3">{term}</dt>
                <dd className="mt-1 text-sm text-ink">{desc}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
